/**
 * Integration req's for directory wholesale landing pages, e.g. /wholesale/artificial-flowers
 */
(function($){

    function getTerm(target) {
        return $.trim($(target).closest('.row').find('h3').text().replace(/^\d+\./, ''));
    }

    /**
     * Note: DirectoryAccess is set in app/views/v5/layouts/landing_directory_wholesale.ctp
     */
    if (DirectoryAccess) {
        $('.d-grid button[data-bs-target=\"#Pricing-Annual\"]').each((i, el) => {
            let $el = $(el),
                $link = $('<a>')
                .attr('href', '/ds/search?query=' + getTerm($el) + '&order=relevance')
                .attr('class', $el.attr('class'))
                .html($el.html());

            $el.replaceWith($link);
        });

        function processSuppliers(response)
        {
            $('.container-list .row').each((i, el) => {
                let suppliers = $(el),
                    supplierEls = suppliers.find('button[data-bs-target=\"#Pricing-Annual\"]'),
                    suppliersData = response.suppliers[i],
                    suppliersFound = suppliersData.length;

                if (suppliersFound === 0) {
                    suppliers.find('h5').empty();
                    suppliers.find('.table-details').empty();
                    return;
                }

                supplierEls.each((i, supplierEl) => {
                    let supplier = $(supplierEl),
                        supplierData = suppliersData.suppliers[i],
                        query = suppliersData.query;

                    if (supplierData == undefined) {
                        //remove the supplier
                        supplier.closest('tr').empty();
                    } else {
                        supplier.next('span.sup-link').empty();

                        let supplierRow = supplier.closest('tr');

                        // Business age
                        supplierRow.find('td:eq(1)').text(supplierData.business_age + ' ' + (supplierData.business_age > 1 ? 'Years' : 'Year'));

                        // Ships
                        supplierRow.find('td:eq(2)').text(supplierData.ships_worldwide ? 'Worlwide' : '');

                        let seller = supplierData.name || 'Wholesale Supplier';
                        if (seller.length > 20) {
                            seller = $.trim(seller.substring(0, 20)) + '&hellip;';
                        }
                        let supplierActual = $('<a>', {
                            href: '/suppliers/' + supplierData.slug,
                            title: seller,
                            class: 'text-dark link-hover-underline text-truncate sup-link',
                            html: seller
                        });
                        supplier.replaceWith(supplierActual);
                    }
                });
            });
        }

        const productQueries = [];
        $('.container-list .row').find('h4').each((i, el) => {
            productQueries.push($.trim($(el).text().replace(/^\d+\./, '')));
        });
        
        $.ajax({
            url: '/directory_wholesale/suppliers',
            method: 'post',
            data : {
                data : {
                    query: productQueries
                }
            }
        }).then(processSuppliers);
    }
})(jQuery);